module.exports = __webpack_public_path__ + "img/dcms-dashboard.ff66e860.svg";